module.exports = __webpack_public_path__ + "static/media/task.9c4785bf.svg";